<!--
  风险等级下拉选择组件
  使用示例：
  <select-level-list v-model="search.levelList"></select-level-list>
-->
<template>
  <base-el-select v-model="value" :options="options" @input="handleInput" />
</template>

<script>
import BaseElSelect from './BaseElSelect.vue';
export default {
  name: 'SelectLevelList',
  props: ['value'],
  components: {
    BaseElSelect
  },
  data: () => {
    return {
      options: [
        { bgColor: '#267DE0', color: '#FFFFFF', label: '打回任务池', value: '-1' },
        { bgColor: '#0dc84f', color: '#FFFFFF', label: '风险0级', value: '0' },
        { bgColor: '#fff046', color: '#333333', label: '风险1级', value: '1' },
        { bgColor: '#ffa200', color: '#FFFFFF', label: '风险2级', value: '2' },
        { bgColor: '#e22b00', color: '#FFFFFF', label: '风险3级', value: '3' },
        { bgColor: '#DCC2E9', color: '#333333', label: '需要翻译', value: '9' },
        { bgColor: '#ffa200', color: '#FFFFFF', label: '机翻直出', value: '10' },
        { bgColor: '#DCC2E9', color: '#333333', label: '例句填充', value: '99' },
      ].map((item) => ({
        label: item.label,
        value: item.value,
        style: `background-color:${item.bgColor}; color:${item.color}; border-bottom: 1px solid #fff;`
      })),
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    }
  }
}
</script>
